import { render } from "./batch_up_file.vue?vue&type=template&id=0715bd66&scoped=true"
import script from "./batch_up_file.vue?vue&type=script&lang=js"
export * from "./batch_up_file.vue?vue&type=script&lang=js"

import "./batch_up_file.vue?vue&type=style&index=0&id=0715bd66&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0715bd66"]])

export default __exports__